import React, { useContext } from 'react';

const EMPTY = {
    onStart2Fa() {
        console.error('Two factor start function');
    },
    onDone() {
        console.error('Two factor done');
    }
};

const TwoFactorContext = React.createContext(EMPTY);

export const useTwoFactorContext = () => useContext(TwoFactorContext);

export function TwoFactorProvider({ config, children }) {
    return <TwoFactorContext.Provider value={config}>{children}</TwoFactorContext.Provider>;
}
